/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconArchiveLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 12 10">
    <g fill="white" stroke="currentColor">
    <rect width="9" height="9" x="1.5" y=".5" />
    <rect width="11" height="2" x=".5" y=".5" rx=".5" />
    <line x1="4.5" y1="5" x2="7.5" y2="5" strokeLinecap="round" />
</g>
  </Icon>
);
};

IconArchiveLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMCI+CiAgPGcgZmlsbD0id2hpdGUiIHN0cm9rZT0iY3VycmVudENvbG9yIj4KICAgIDxyZWN0IHdpZHRoPSI5IiBoZWlnaHQ9IjkiIHg9IjEuNSIgeT0iLjUiLz4KICAgIDxyZWN0IHdpZHRoPSIxMSIgaGVpZ2h0PSIyIiB4PSIuNSIgeT0iLjUiIHJ4PSIuNSIvPgogICAgPGxpbmUgeDE9IjQuNSIgeTE9IjUiIHgyPSI3LjUiIHkyPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8L2c+Cjwvc3ZnPg==";
IconArchiveLineComponent.Content = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 10">
  <g fill="white" stroke="currentColor">
    <rect width="9" height="9" x="1.5" y=".5"/>
    <rect width="11" height="2" x=".5" y=".5" rx=".5"/>
    <line x1="4.5" y1="5" x2="7.5" y2="5" stroke-linecap="round"/>
  </g>
</svg>`;

const IconArchiveLine = styled(IconArchiveLineComponent)``;

export default IconArchiveLine;
